// @flow
import React, { Component } from 'react';
import Pog from 'app/common/react/ui/experimental/Pog';
import { Box } from 'gestalt';
import NavigateLink, { NAV_MAP } from 'app/common/react/ui/NavigateLink';

type Props = {|
  accessibilityLabel: string,
  experienceAnchor?: string,
  children?: any,
  onClick?: (e: SyntheticMouseEvent<>) => void,
  shape?: 'rounded' | 'pill' | 'circle',
  url: string,
  useNewTab?: boolean,
  isInitiallyHovered?: boolean,
  handleMouseEnter?: Function,
  handleMouseLeave?: Function,
|};

type State = {|
  active: boolean,
  focused: boolean,
  hovered: boolean,
|};

export default class LinkPogWrapper extends Component<Props, State> {
  state: State = {
    active: false,
    focused: false,
    hovered: this.props.isInitiallyHovered || false,
  };

  handleBlur = () => this.setState({ focused: false });

  handleFocus = () => this.setState({ focused: true });

  handleMouseDown = () => this.setState({ active: true });

  handleMouseEnter = () => {
    const { handleMouseEnter } = this.props;
    if (handleMouseEnter) {
      handleMouseEnter();
    }

    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    const { handleMouseLeave } = this.props;
    if (handleMouseLeave) {
      handleMouseLeave();
    }

    this.setState({
      active: false,
      hovered: false,
    });
  };

  handleMouseUp = () => this.setState({ active: false });

  render() {
    const {
      accessibilityLabel,
      experienceAnchor,
      children,
      onClick,
      shape = 'pill',
      url,
      useNewTab,
    } = this.props;
    const { active, focused, hovered } = this.state;
    const display = shape === 'pill' ? 'flex' : 'flexColumn';
    const padding = shape === 'pill' ? 2 : 1;
    const size = shape === 'circle' ? 48 : '';

    const NavLink = experienceAnchor ? NAV_MAP[experienceAnchor] : NavigateLink;

    return (
      <Box position="relative">
        <Box
          aria-label={accessibilityLabel}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          onMouseDown={this.handleMouseDown}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onMouseUp={this.handleMouseUp}
        >
          {/* We disable the pinboard native focus styles since Pog already provides those */}
          <NavLink
            className="dangerouslyDisableFocusStyle"
            focusOnBody
            onClick={onClick}
            to={url}
            external={useNewTab}
            useNewTab={useNewTab}
          >
            <Pog active={active} focused={focused} hovered={hovered} shape={shape}>
              <Box
                xs={{ display }}
                alignItems="center"
                justifyContent="center"
                padding={padding}
                height={size}
                width={size}
              >
                {children}
              </Box>
            </Pog>
          </NavLink>
        </Box>
      </Box>
    );
  }
}
